import * as React from 'react';
import clsx from 'clsx';
import loadable from '@loadable/component';
import styles from './layout.module.css';
import Layout from 'components/layout';
import Header from './header';
// import SubscribeForm from '../subscribe-form';
import Footer from 'components/layout/footer';
import SubNavigation from './nav';

import { meta as metaData } from '../../metaData';
import { Topic } from './Types';

interface Props {
  children: React.ReactNode;
  tag?: object | undefined;
  topics: ReadonlyArray<Topic>;
}

const SubscribeForm = loadable(() => import('components/subscribe-form'));

function Main({ children, topics, tag }: Props) {
  const metaBase = {
    title: 'Blog about Startups, Web development and Mobile Development',
    description:
      'Dive into Brocoders in-depth insights to learn more about the latest tech trends and our relevant expertise',
  };

  const [meta, setMeta] = React.useState(metaBase);

  React.useEffect(() => {
    switch (location.pathname) {
      case '/blog/news/': {
        setMeta({
          title: metaBase.title + ' | Company news',
          description: metaBase.description + ' | Company news',
        });
        break;
      }
      case '/blog/research-development/': {
        setMeta({
          title: metaBase.title + ' | Research and development',
          description: metaBase.description + ' | Research and development topic',
        });
        break;
      }
      case '/blog/ceo-insights/': {
        setMeta({
          title: metaBase.title + ' | CEO insights',
          description: metaBase.description + ' | CEO insights topic',
        });
        break;
      }
      case '/blog/interview/': {
        setMeta({
          title: metaBase.title + ' | Interview',
          description: metaBase.description + ' | Interview topic',
        });
        break;
      }
      case `/blog/tags/${tag?.slug}/`: {
        const tagName = tag.title[0].toUpperCase() + tag.title.slice(1);
        setMeta({
          title: metaBase.title + ` | ${tagName}`,
          description: metaBase.description + ` | ${tagName}`,
        });
        break;
      }
      default: {
        setMeta({
          title: metaBase.title,
          description: metaBase.description,
        });
        break;
      }
    }
  }, []);

  return (
    <Layout
      isRed
      metaData={{ main: { ...metaData.blog, title: meta.title, description: meta.description } }}
    >
      <Header subNavigation={() => <SubNavigation topics={topics} />}>
        <div className={styles.column}>
          <h1 className={styles.title}>Blog</h1>
          <p className={styles.subtitle}>
            Dive into Brocoders in-depth insights to learn more about the latest tech trends and our
            relevant expertise
          </p>
        </div>
        <div className={styles.column}>
          <SubscribeForm label="Stay tuned" variant="blog" />
        </div>
      </Header>
      <main className={clsx('main', styles.main)}>{children}</main>
      <Footer isPrevBgdWtite={true} />
    </Layout>
  );
}

export default Main;
